module.exports = __webpack_public_path__ + "static/blog-14-48712e26201c4284ceb7f3ae1fe46ab1.png";